stimulusApp.register(
  "cruise-venues",
  class extends Stimulus.Controller {
    static targets = [
      "modal",
      "list",
      "detail",
      "categoryPanel",
      "image",
      "placeholder",
      "counter",
      "thumbs",
      "title",
      "category",
      "tag",
      "description",
    ]

    connect() {
      this.photos = []
      this.index = 0
    }

    open(event) {
      const { name, category, tag, description, photos } = event.params
      this.photos = this.#photosFromParam(photos)
      this.index = 0

      this.openedFromList = !this.modalTarget.hidden && !this.listTarget.hidden
      this.titleTarget.textContent = name || ""
      this.categoryTarget.textContent = category || ""
      this.descriptionTarget.textContent = description || ""

      if (tag) {
        this.tagTarget.textContent = tag
        this.tagTarget.hidden = false
      } else {
        this.tagTarget.hidden = true
      }

      this.#render()
      this.#showView("detail")
      this.#show()
    }

    openCategory(event) {
      const { categoryId } = event.params

      this.categoryPanelTargets.forEach((panel) => {
        panel.hidden = panel.dataset.categoryId !== String(categoryId)
      })

      this.#showView("list")
      this.#show()
    }

    closeDetail() {
      if (this.openedFromList) {
        this.#showView("list")
      } else {
        this.close()
      }
    }

    close() {
      this.modalTarget.hidden = true
      this.modalTarget.classList.remove("cruises--modal_open")
      document.body.classList.remove("cruises-modal-open")
    }

    backdropClose() {
      this.close()
    }

    stop(event) {
      event.stopPropagation()
    }

    prev() {
      if (this.photos.length === 0) return
      this.index = (this.index - 1 + this.photos.length) % this.photos.length
      this.#render()
    }

    next() {
      if (this.photos.length === 0) return
      this.index = (this.index + 1) % this.photos.length
      this.#render()
    }

    #show() {
      this.modalTarget.hidden = false
      this.modalTarget.classList.add("cruises--modal_open")
      document.body.classList.add("cruises-modal-open")
    }

    #showView(view) {
      this.listTarget.hidden = view !== "list"
      this.detailTarget.hidden = view !== "detail"
    }

    #select(event) {
      this.index = Number(event.currentTarget.dataset.index)
      this.#render()
    }

    #photosFromParam(photos) {
      if (Array.isArray(photos)) return photos
      if (typeof photos !== "string") return []

      try {
        const parsed = JSON.parse(photos)
        return Array.isArray(parsed) ? parsed : []
      } catch {
        return []
      }
    }

    #render() {
      const hasPhotos = this.photos.length > 0
      const multiple = this.photos.length > 1

      this.imageTarget.hidden = !hasPhotos
      this.placeholderTarget.hidden = hasPhotos
      this.counterTarget.hidden = !multiple

      this.element
        .querySelectorAll(".cruises--modal--nav")
        .forEach((button) => (button.hidden = !multiple))

      if (hasPhotos) {
        const photo = this.photos[this.index]
        this.imageTarget.src = photo.url
        this.imageTarget.alt = photo.alt || ""
        this.counterTarget.textContent = `${this.index + 1} / ${this.photos.length}`
      }

      this.#renderThumbs()
    }

    #renderThumbs() {
      this.thumbsTarget.replaceChildren()
      if (this.photos.length < 2) return

      this.photos.forEach((photo, position) => {
        const thumb = document.createElement("button")
        thumb.type = "button"
        thumb.className = "cruises--modal--thumb"
        thumb.dataset.index = position
        if (position === this.index)
          thumb.classList.add("cruises--modal--thumb_active")
        thumb.addEventListener("click", (event) => this.#select(event))

        const img = document.createElement("img")
        img.src = photo.thumbnailUrl || photo.url
        img.alt = photo.alt || ""
        thumb.appendChild(img)
        this.thumbsTarget.appendChild(thumb)
      })
    }
  },
)
